// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34xBQ","question":"styles_question__1Cm-D","description":"styles_description__1qwcV"};